module.exports = __webpack_public_path__ + "./Joan_7b23e84eee6c5570ba79fa843d5c3f13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Joan.jpg
// module id = 564
// module chunks = 0